<template>
  <div class="green__products">
    <form
        action=""
        @submit.prevent="createSlider"
        class="green__column green__message"
        style="padding: 20px"
    >
      <div class="green__column green__input item__mb">
        <b class="item__mb">Загрузить рисунок для банера</b>
        <input type="file" multiple @change="uploadBanner" />
      </div>
      <button type="submit">Отправить</button>
    </form>

    <div class="item__row item__ac banners">
      <div
          class="item__column green__mr__xs"
          v-for="item in banner_images"
          :key="item.id"
      >
        <img
            class="item__mb"
            :src="'https://api.kerimqoloner.kz' + item.image_path"
            alt=""
        />
        <i class="fas fa-trash-alt" @click="deleteBanner(item.id)"></i>
      </div>
    </div>
  </div>
</template>



<script>
export default {
  data() {
    return {
      banners: [],
      banner_images: []
    }
  },
  methods: {
    uploadBanner(e) {
      const file = e.target.files;
      for (var i = 0; i < file.length; i++) {
        this.banners.push(file[i]);
      }
    },
    deleteBanner(id) {
      let data = {
        id: id,
      };
      this.$http
          .post("/del/banner", data, {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          })
          .then((res) => {
            this.$toast.open({
              message: res.data.message,
              type: "success",
              position: "bottom",
              duration: 5000,
              queue: true,
            });
            this.getBanner();
          });
    },
    createSlider() {
      let fd = new FormData();
      for (let i = 0; i < this.banners.length; i++) {
        fd.append("images[]", this.banners[i]);
      }
      this.$http
          .post("/create/banner", fd, {
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            this.$toast.open({
              message: res.data.message,
              type: "success",
              position: "bottom",
              duration: 5000,
              queue: true,
            });
            this.getBanner();
          });
    },
    getBanner() {
      const config = {
        headers: { Authorization: `Bearer ${this.token}` },
      };
      this.$http.get("/get/banners", config).then((res) => {
        this.banner_images = res.data;
      });
    },

  },
  mounted() {
    if (localStorage.getItem("access_token")) {
      this.token = localStorage.getItem("access_token");
      this.$http
          .post(
              "/get/user/me",
              {},
              {
                headers: {
                  Authorization: `Bearer ${this.token}`,
                },
              }
          )
          .then((res) => {
            this.user.id = res.data.id;
            this.page = 1;
            this.user.role = res.data.name;
            this.user = res.data;
            this.getBanner()
          });
    } else {
      this.$router.push("/login");
    }
  }
}
</script>

<style scoped lang="less">
.admin__loader {
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  z-index: 10;
  bottom: 0;
  background-image: linear-gradient(
      to right,
      #253532,
      #1e363d,
      #273345,
      #3c2e43,
      #4c2934
  );

  i {
    font-size: 36px;
    color: white;
  }
  p {
    font-size: 36px;
    color: white;
  }
}
@mobile: 900px;
@planshet: 1200px;
.mdi-logout {
  font-size: 26px;
  position: absolute;
  right: 20px;
  color: white;
  top: 20px;
}
.bonus__actions {
  width: 100%;
  z-index: 10;
  position: fixed;
  background: #191a21;
  bottom: 0;
  padding: 20px;
  .bonus__actions__btn {
    i {
      color: white;
      font-size: 32px;
    }
  }
  // p {
  //     padding: 15px;
  //     background-image: linear-gradient(to right, #131215, #1d161e, #2b1824, #3a1924, #481b20);
  //     border-radius: 20px;
  //     color: white;
  //     text-align: center;
  //     font-weight: bold;
  //     cursor: pointer;
  //     @media (max-width: @mobile) {
  //        padding: 10px;
  //        font-size: 14px;
  //     }
  // }
}
.modal__bonus {
  .modal__bonus__title {
    font-size: 22px;
    font-weight: bold;
    text-align: center;
    color: #4c2934;
  }
  .modal__bonus__result {
    margin-bottom: 10px;
    p {
      font-size: 18px;
      color: #0069ff;
      span {
        font-weight: bold;

        font-size: 20px;
      }
    }
  }
  .modal__bonus__label {
    margin-bottom: 15px;
  }
  input {
    padding: 10px;
    outline: none;
    border: 1px solid #ccc;
  }

  .modal__bonus__btn {
    border-radius: 20px;
    padding: 20px;
    text-align: center;
    justify-content: center;
    background-image: linear-gradient(
        to right,
        #253532,
        #1e363d,
        #273345,
        #3c2e43,
        #4c2934
    );
    p {
      color: white;
      font-weight: bold;
    }
    i {
      color: white;
    }
  }
}



.green__active {
  background: #0069ff;
  color: white;
  padding: 5px;
}
.banners {
  overflow-x: scroll;
  i {
    cursor: pointer;
  }
  img {
    width: 100px;
    height: 100px;
    object-fit: cover;
  }
}
.green__notif_position {
  bottom: 200px;
}
p {
  margin-bottom: 0 !important;
}

.green__mb__xs {
  margin-bottom: 10px;
}
.green__mb__s {
  margin-bottom: 20px !important;
}
.green__ml__l {
  margin-left: 20px;
}
.green__mr__xs {
  margin-right: 10px;
}
.green__100 {
  width: 100%;
}
.green__row {
  display: flex;
  flex-direction: row;
}
.green__ac {
  align-items: center;
}
.green__jb {
  justify-content: space-between;
}
.green__column {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  @media (max-width: @mobile) {
    width: 100%;
  }
}
.green__abs {
  display: flex;
  justify-content: center;
  align-items: center;
}

.green__pointer {
  cursor: pointer;
}

.green__btn__color {
  color: #0069ff;
}
.green__btn__color:hover {
  opacity: 0.6;
}

.green__admin {
  min-height: 100vh;

  align-items: center;
  justify-content: center;

  .green__see {
    font-size: 18px;
    font-weight: bold;
    @media (max-width: 900px) {
      font-size: 12px;
      white-space: nowrap;
    }
  }
  .green__see--active {
    color: #0069ff;
  }
  .green__images__title {
    margin-top: 40px;
    color: #0069ff;
    font-size: 16px;
    font-weight: bold;
    text-transform: uppercase;
  }

  .green__product__images__main::-webkit-scrollbar {
    height: 5px;
  }

  .green__product__images__main::-webkit-scrollbar-track {
    border-radius: 2px;
    background-color: #ccc;
  }
  .green__product__images__main::-webkit-scrollbar-thumb {
    background-color: #0069ff;
    border-radius: 2px;
    height: 24px;
    width: 50px;
  }
  .green__product__images__main {
    overflow-x: auto;
    width: 50%;
  }
  .green__product__images {
    margin-bottom: 5px;
    margin-top: 5px;
    img {
      width: 70px;
      height: 70px;
      border-radius: 10px;
      object-fit: cover;
      margin-right: 30px;
    }
  }

  .green__logout {
    align-self: flex-end;
    padding: 10px;
    background-image: linear-gradient(
        to right,
        #253532,
        #1e363d,
        #273345,
        #3c2e43,
        #4c2934
    );
    color: white;
    margin-bottom: 20px;
    width: 140px;
    text-align: center;
  }
  .green__logout:hover {
    background: #5c8a0d;
  }

  .green__left {
    width: 20%;
    padding: 20px;
    background: #ffffff;
    box-shadow: 0px 8px 40px rgba(0, 0, 0, 0.05);
    border-radius: 2px;

    margin-right: 20px;
    min-height: 100px;
    border-radius: 10px;

    @media (max-width: @mobile) {
      width: 100%;
      margin-left: 0;
      margin-bottom: 20px;
    }

    p {
      font-weight: bold;
      cursor: pointer;
    }
    i {
      color: white;
    }
  }

  .green__right {
    padding: 20px;
    background: #ffffff;
    box-shadow: 0px 8px 40px rgba(0, 0, 0, 0.05);
    border-radius: 10px;


    i {
      color: white;
    }

    .green__parents {
      p {
        font-size: 20px;
      }
      i {
        background: #0069ff;
        padding: 10px;
        font-size: 22px;
        border-radius: 50%;
        margin-right: 10px;
      }
      i:hover {
        opacity: 0.8;
      }
    }
    .green__choose {
      margin-bottom: 20px;
      .green__category__choose {
        cursor: pointer;
        padding: 20px;
        background: gray;
        margin-right: 10px;
        color: white;
        @media (max-width: @mobile) {
          font-size: 14px;
        }
        border-radius: 20px;
      }
      .green__category__active {
        background: #0069ff;
      }
    }

    .green__input {
      width: 300px;
      @media (max-width: @mobile) {
        width: 100%;
      }
      .green__input__write {
        border: 1px solid black;
        padding: 20px;
        border-radius: 2px;
        outline: none;
      }
    }
    button {
      width: 300px;
      outline: none;
      border: none;
      padding: 15px;
      background: #0069ff;
      font-weight: bold;
      @media (max-width: @mobile) {
        width: 100%;
      }
    }

    .green__edit {
      margin-bottom: 20px;
      border-radius: 2px;
      border: 1px solid #ccc;
      padding: 20px;

      a {
        color: #0069ff !important;
      }

      .green__user__orders {
        margin-top: 30px;
        margin-left: 10px;

        .green__user__title {
          font-weight: bold;
          font-size: 18px;
        }
      }

      @media (max-width: @mobile) {
        margin-left: 0;
      }
      .green__last__action {
        p {
          font-size: 12px;
        }
      }

      .green__data {
        margin-bottom: 10px;
        color: #0069ff;
        font-size: 18px;
      }
      .green__save__btn {
        color: #0069ff;
      }

      button {
        width: 300px;
        outline: none;
        border: none;
        background-color: #0069ff;
        color: white;
        padding: 20px;
        @media (max-width: @mobile) {
          width: 100%;
        }
      }
    }
  }
}

.green__message {
  button {
    outline: none;
    border: none;
    background-color: #0069ff;
    color: white;
    padding: 20px;
  }
}

.green__admin__inner {
  @media (max-width: @mobile) {
    flex-direction: column;
  }
}
</style>
